export const normalizePatientEmail = (value) => (
  typeof value === "string" ? value.trim().toLowerCase() : ""
);

export const patientIdentityMatchesEmail = (patient, email) => {
  const patientEmail = normalizePatientEmail(patient?.email);
  const submittedEmail = normalizePatientEmail(email);
  return Boolean(patientEmail && submittedEmail && patientEmail === submittedEmail);
};

export const patientIdentitySnapshot = (patient) => {
  if (!patient) return null;
  return {
    patientId: String(patient.patient_id || patient.id || ""),
    email: normalizePatientEmail(patient.email),
  };
};

export const patientIdentityKey = (patient) => {
  const snapshot = patientIdentitySnapshot(patient);
  if (!snapshot) return "";
  return snapshot.patientId || snapshot.email;
};

export const samePatientIdentity = (left, right) => {
  const leftSnapshot = patientIdentitySnapshot(left);
  const rightSnapshot = patientIdentitySnapshot(right);
  if (!leftSnapshot || !rightSnapshot) return false;
  if (leftSnapshot.patientId && rightSnapshot.patientId) {
    return leftSnapshot.patientId === rightSnapshot.patientId;
  }
  return Boolean(
    leftSnapshot.email
    && rightSnapshot.email
    && leftSnapshot.email === rightSnapshot.email
  );
};

export const isRuntimePatientPermissionError = (error) => (
  error?.code === "runtime_patient_permission_required"
  || error?.code === "runtime_patient_mismatch"
  || error?.response?.data?.error === "runtime_patient_permission_required"
  || error?.response?.data?.code === "runtime_patient_mismatch"
  || error?.message === "runtime_patient_permission_required"
  || error?.message === "runtime_patient_mismatch"
);
